import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function Successfulprojects() {
  return (
    <section className="successful_projects p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Our Top-Performing ReactJS{" "}
              <span>Projects for Business Growth</span>
            </h2>
            {/* <p>
              Hire iOS app developers with TekRevol for intuitive, robust, and
              visually appealing apps that align with your user interaction and
              strategic business goals. By leveraging the latest technologies
              and development frameworks, we ensure that your iOS applications
              are not only functional but also scalable and future-proof.
            </p> */}
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              // autoplay={false}
              spaceBetween={20}
              modules={[Autoplay, Pagination]}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 1,
                },
                1024: {
                  slidesPerView: 1.3,
                },
                1366: {
                  slidesPerView: 1.4,
                },
                1600: {
                  slidesPerView: 1.6,
                },
              }}
              className="web_case_slider"
            >
              <SwiperSlide>
                <div className="web_pro_item item-1">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/services-usa/android-new/projects/pure_plank_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={189}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        Bringing a New Concept to the Health and Fitness Journey
                      </h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>40%</h5>
                        <p>ROI Growth</p>
                      </div>
                      <div className="android_item">
                        <h5>60%</h5>
                        <p>Improvement in Fitness</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/pure-plank"
                        aria-label="TekRevol Contact"
                        className="border_btn"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/services-usa/android-new/projects/pure_plank_img.webp"
                      alt="pure plank"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={599}
                      height={685}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item item-2">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/services-usa/android-new/projects/reckn.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={75}
                        height={75}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        Elevating the Restaurant Experience with Impeccable
                        Booking & Socialization
                      </h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>65%</h5>
                        <p>ROI Growth</p>
                      </div>
                      <div className="android_item">
                        <h5>50%</h5>
                        <p>Growth in conversion rates</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/reck-n-case"
                        className="border_btn"
                        aria-label="TekRevol Contact"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/services-usa/android-new/projects/reckn_img.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item item-3">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/services-usa/android-new/projects/onsite_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={161}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        Bridging the Gap between Local Residents Leveraging
                        Real-time Locations
                      </h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>35%</h5>
                        <p>ROI Growth</p>
                      </div>
                      <div className="android_item">
                        <h5>55%</h5>
                        <p>Improvement in Connections</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/onsite"
                        className="border_btn"
                        aria-label="TekRevol Contact"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/services-usa/android-new/projects/onsite_img.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="web_pro_item item-1">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/services-usa/android-new/projects/pure_plank_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={189}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        Bringing a New Concept to the Health and Fitness Journey
                      </h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>40%</h5>
                        <p>ROI Growth</p>
                      </div>
                      <div className="android_item">
                        <h5>60%</h5>
                        <p>Improvement in Fitness</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/pure-plank"
                        aria-label="TekRevol Contact"
                        className="border_btn"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/services-usa/android-new/projects/pure_plank_img.webp"
                      alt="pure plank"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={599}
                      height={685}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item item-2">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/services-usa/android-new/projects/reckn.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={75}
                        height={75}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        Elevating the Restaurant Experience with Impeccable
                        Booking & Socialization
                      </h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>65%</h5>
                        <p>ROI Growth</p>
                      </div>
                      <div className="android_item">
                        <h5>50%</h5>
                        <p>Growth in conversion rates</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/reck-n-case"
                        className="border_btn"
                        aria-label="TekRevol Contact"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/services-usa/android-new/projects/reckn_img.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item item-3">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../images/services-usa/android-new/projects/onsite_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={161}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        Bridging the Gap between Local Residents Leveraging
                        Real-time Locations
                      </h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>35%</h5>
                        <p>ROI Growth</p>
                      </div>
                      <div className="android_item">
                        <h5>55%</h5>
                        <p>Improvement in Connections</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/onsite"
                        className="border_btn"
                        aria-label="TekRevol Contact"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../images/services-usa/android-new/projects/onsite_img.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="mt-md-4 mt-3 text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Hire Top Reactjs Talent
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Successfulprojects;
